import { Box, BoxProps, useTheme } from "@mui/material";

interface MainContainerProps extends Omit<BoxProps, "maxWidth"> {
  maxWidth?: string;
  noPadding?: boolean;
}

export default function MainContainer({
  children,
  maxWidth = "1200px",
  noPadding = false,
  sx,
  ...props
}: MainContainerProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        maxWidth,
        margin: "0 auto",
        padding: noPadding ? 0 : theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
          padding: noPadding ? 0 : theme.spacing(1),
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
